// Import jQuery for this module
import $ from 'jquery';

(function($){
	$(document).ready(function(){

		// Setup CSRF token for all AJAX requests
		$.ajaxSetup({
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			}
		});

		// toggle cover
		var elCover = $('#bgcover');
		if(elCover.length > 0) {
			//console.log(elCover);
			$('fa', elCover).toggleClass('');
			$('#bgcover-view-toggle', elCover).on( "click", function(event) {
				event.preventDefault();
				//e.log(elCover);
				$(elCover).toggleClass('fullscreen');
			});
		}

		// toggle credits, priceinfo and regular datelist
		var elCredits = $('#datelist:not(.multilist)');
		if(elCredits.length > 0) {
			$(elCredits).addClass('collapsed');
			$('fa', elCredits).toggleClass('');
			elCredits.each(function() {
				var collapsable = $(this);
				$('h3', this).on( "click", function() {
					collapsable.toggleClass('collapsed');
					//$('.inner', elCredits).toggleClass('collapsed');
				});
			});
		}

		// toggle datelist
		var elDatelists = $('#datelist.multilist');
		if(elDatelists.length > 0) {
			if ($('.sublist h3 .toggle', elDatelists).length > 0) {
				$('.sublist', elDatelists).addClass('collapsed');
				$('fa', elDatelists).toggleClass('');
				$('.sublist', elDatelists).each(function() {
					var collapsable = $(this);
					//console.log(collapsable);
					$('h3', this).on( "click", function() {
						//console.log(collapsable, $(this));
						collapsable.toggleClass('collapsed');
						//$('.inner', elCredits).toggleClass('collapsed');
					});
				});
			}
		}

		// open filter
		var elFilter = $('#filter');
		if(elFilter.length > 0) {
			$('> a', elFilter).on( "click", function(event) {
				event.preventDefault();
				if ($("#filter-box").prop("hidden")) {
					$("#filter-box").prop("hidden", false);
				} else {
					$("#filter-box").prop("hidden", true);
				}
				$(this).toggleClass('open');
			});
		}

		// init event image carousel
		var imagecarousel = $('#imagecarousel .images').slick({
		  dots: true,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  centerMode: true,
			variableWidth: true,
			arrows: false
		});
		$('#imagecarousel .slider-controls a').on("click", function() {
			if($(this).attr('rel') == 'prev') {
				imagecarousel.slick('slickPrev');
			} else if ($(this).attr('rel') == 'next') {
				imagecarousel.slick('slickNext');
			}
		});
		// handle external videos by cookies
		/* $('#imagecarousel .images .video').each( function( i, e ) {
			console.log( i, e, document.cookie);
		}); */

		// init responsive image carousel
		$('.carousel[data-type="multi"] .item').each(function() {
			var next = $(this).next();
			if (!next.length) {
				next = $(this).siblings(':first');
			}
			next.children(':first-child').clone().appendTo($(this));

			for (var i = 0; i < 2; i++) {
				next = next.next();
				if (!next.length) {
					next = $(this).siblings(':first');
				}

				next.children(':first-child').clone().appendTo($(this));
			}
		});

		// add lightbox
		$(document).on('click', '[data-toggle="lightbox"]', function(event) {
			event.preventDefault();
			$(this).ekkoLightbox({
				alwaysShowClose: true,
				/* onShown: function() {
						console.log('Checking our the events huh?');
				},
				onNavigate: function(direction, itemIndex){
						console.log('Navigating '+direction+'. Current item: '+itemIndex);
				} */
			});
		});

		// landing full-width video: swap preview for an inline, fullscreen-capable player
		$(document).on('click', '.landing-video-frame[data-player] .landing-video-trigger', function(event) {
			event.preventDefault();
			var frame = $(this).closest('.landing-video-frame');
			var src = frame.attr('data-player');
			if (!src) {
				return;
			}
			var iframe = $('<iframe>', {
				'class': 'landing-video-iframe',
				src: src,
				frameborder: 0,
				allow: 'autoplay; fullscreen; picture-in-picture; encrypted-media',
				title: frame.attr('data-title') || 'Video'
			});
			iframe.attr('allowfullscreen', '');
			frame.addClass('is-playing').html(iframe);
		});

		var externalcookie = $('#externalcookie');

		// open externalcookie box
		$('.openExternalcookie').on( "click", function(event) {
			event.preventDefault();
			let provider = $(event.currentTarget).attr('data-provider');
			switch (provider) {
				case 'vimeo': 		$('.info.vimeo').attr('hidden', false); break;
				case 'youtube': 	$('.info.youtube').attr('hidden', false); break;
				case 'fitogram': 	$('.info.fitogram').attr('hidden', false); break;
				default: 					$('.info.default').attr('hidden', false); break;
			}
			externalcookie.attr("hidden", false);
			externalcookie.attr('data-provider', provider);
		});

		// close externalcookie box
		$('.close', externalcookie).on( "click", function(event) {
			externalcookie.attr("hidden", true);
		});

		// reject externalcookie box
		$('.reject', externalcookie).on( "click", function(event) {
			externalcookie.attr("hidden", true);
		});

		// accept externalcookie box
		$('.accept', externalcookie).on( "click", function(event) {
			let provider = externalcookie.attr('data-provider');
			document.cookie = `external-${(provider ? provider : 'default')}=1`;
			externalcookie.attr("hidden", true);
			location.reload();
		});


		// search autocomplete
		var elSearchbox = $('#search-box');
		var elSearchboxResult = $('#search-box-results');
		if (elSearchbox.length > 0) {
			var autosearchTimer = null;
			var autosearchRequest = null;
			var AUTOSEARCH_DEBOUNCE_MS = 250;

			var renderAutosearch = function (responseHtml) {
				if (responseHtml.length > 0) {
					$('.results-content', elSearchboxResult).html(responseHtml);
					elSearchboxResult.show();
				} else {
					$('.results-content', elSearchboxResult).html('');
					elSearchboxResult.hide();
				}
			};

			$('input[name=q]', elSearchbox).on('input', function () {
				var q = $( this ).val();

				// Debounce: without this every keystroke triggers a full-table
				// LIKE scan, and slow responses can land out of order.
				clearTimeout(autosearchTimer);
				if (autosearchRequest) {
					autosearchRequest.abort();
					autosearchRequest = null;
				}

				if (q.length <= 2) {
					renderAutosearch('');
					return;
				}

				autosearchTimer = setTimeout(function () {
					autosearchRequest = $.ajax({
						type: 'POST',
						url: "/autosearch",
						dataType: "html",
						data: {
							'q': q
						},
						success: function( responseHtml ) {
							renderAutosearch(responseHtml);
						}
					}).always(function () {
						autosearchRequest = null;
					});
				}, AUTOSEARCH_DEBOUNCE_MS);
			});
		}

		// open mini calendar
		var elMinicalTrigger = $('#minical-trigger');
		var elMinicalContainer = $('#minical-container');
		if (elMinicalTrigger.length > 0 && elMinicalContainer.length > 0) {
			elMinicalTrigger.hover(function() {

				// inital calendar load
				if ($('.minical-content', elMinicalContainer).html().length == 0) {

					get_minical('/events/minical');
				}

				elMinicalContainer.show();

				$(document).mouseup(function(e) {		
					if (!elMinicalContainer.is(e.target) && elMinicalContainer.has(e.target).length === 0 && elMinicalContainer.is(':visible') === true) 
					{
						elMinicalContainer.hide();
					}
				});
			});
			
			function get_minical(url)
			{	
				$.ajax({
					url: url ,
					dataType: "html",
					success: function( responseHtml ) {
						if(responseHtml.length > 0) {
							$('.minical-content', elMinicalContainer).html(responseHtml);
							$('.header .prev, .header .next', elMinicalContainer).click(function(event) {
								event.preventDefault();
								var skip_url = $('a', this).attr('rel');
								get_minical(skip_url);
							});
						} else {
							$('.minical-content', elMinicalContainer).html('');
						}
					}
				});
			}

		}
		


		// init share — Web Share API with custom sharebox fallback
		if (og !== undefined) {
			var sharebox = $('#sharebox');

			$('.openSharebox').on('click', function(event) {
				event.preventDefault();

				var addition = $(this).attr('data-addition');
				var shareTitle = (addition) ? addition : og.title;

				if (navigator.share) {
					navigator.share({
						title: shareTitle,
						url: og.url,
						text: shareTitle,
					}).catch(function() {
						// User cancelled or browser blocked — ignore
					});
				} else {
					// Fallback: custom sharebox for browsers without Web Share API
					sharebox.attr('hidden', false);
					$('.set .item', sharebox).each(function() {
						var pattern = $('a', this).attr('data-url');
						pattern = pattern.replace('{url}',      encodeURIComponent(og.url));
						pattern = pattern.replace('{img}',      encodeURIComponent(og.image));
						pattern = pattern.replace('{title}',    encodeURIComponent(shareTitle));
						pattern = pattern.replace('{desc}',     encodeURIComponent(og.description));
						pattern = pattern.replace('{via}',      encodeURIComponent(og.site_name));
						pattern = pattern.replace('{hashtags}', encodeURIComponent(og.hashtags));
						$('a', this).attr('href', pattern);
					});
				}
			});

			$('.close', sharebox).on('click', function() {
				sharebox.attr('hidden', true);
			});
		}


		// open course plan
		//*/courses/plan/2019/03
		var courseplanbox = $('#planbox');

		// open course plan
		$('.openCourseplan').on( "click", function(event) {
			event.preventDefault();
			get_courseplan('/courses/plan');
			courseplanbox.attr("hidden", false);

		});

		// open course schedule
		$('.openCourseschedule').on( "click", function(event) {
			event.preventDefault();
			get_courseplan('/courses/schedule');
			courseplanbox.attr("hidden", false);
		});

		// close course plan
		$('.close', courseplanbox).on( "click", function(event) {
			//sharebox.addClass('hidden');
			courseplanbox.attr("hidden", true);
		});

		function get_courseplan(url)
		{	
			$.ajax({
				url: url ,
				dataType: "html",
				success: function( responseHtml ) {
					var htmlBody= $(responseHtml).filter('#modalcontent');
					if(htmlBody.length > 0) {
						$('.content', courseplanbox).html(htmlBody);
						$('.print a', courseplanbox).attr('href', url);
						$('header .prev, header .next', courseplanbox).click(function(event) {
							event.preventDefault();
							var skip_url = $('a', this).attr('rel');
							get_courseplan(skip_url);
						});
						/* $('#navbarTogglerCourseschedule', courseplanbox).click(function(event) {
							event.preventDefault();
							
						}); */
					} else {
						$('.minical-content', courseplanbox).html('');
					}
				}
			});
		}

		// accept fitogram
		$('.fitogram-accept').on( "click", function(event) {
			event.preventDefault();
			document.cookie = `external-fitogram=1`;
			location.reload();
		});


		// bigslider scroll effect
		var bgslider = $('#bgslidervertical');
		if (bgslider.length == 1) {
			var bgslider_last = $('.item:last-child', bgslider);
			var bgslider_scroll_point = bgslider_last.offset().top + 50;
			$(window).scroll(function() {
				if( $(window).scrollTop() >= bgslider_scroll_point ) {
					bgslider.addClass('hide');
					$('.item .caption', bgslider).fadeOut();
				} else {
					bgslider.removeClass('hide');
					$('.item .caption', bgslider).fadeIn();
				}
				//console.log( $(window).scrollTop(), bgslider_scroll_point );
			});
			$('.item .caption', bgslider).click(function(){
				var detail_path = $(this).parents('.item').attr('rel');
				if (detail_path != undefined) {
					window.location = detail_path;
				}
			});
		}
		/*
		if ($('#bgslidervertical').length == 1) {
			$( window ).scroll(function() {
				var currentScroll = $(window).scrollTop();
				$('#bgslidervertical .item').each(function(el) {
					console.log(currentScroll, $(this).offset().top);
					if( $(this).offset().top <= currentScroll) {
						$(this).addClass('fixit');
					} else {
						$(this).removeClass('fixit');
					}
				});
			});
		} // */

		// big slider skip link
		var skip_link = $('#bgslider-view-toggle');
		var bgslider_vertical = $('#bgslidervertical');
		if (skip_link.length > 0 && bgslider_vertical.length > 0) {
			skip_link.on('click', function(event) {
				event.preventDefault();
				var slider_count 	= $('.item', bgslider_vertical).length;
				var slider_height = bgslider_vertical.height() / slider_count;
				var scroll_to			= slider_height * ( Math.round( $(document).scrollTop() / slider_height ) +1 );
				$("html, body").animate({ scrollTop: scroll_to }, 500);
			});
		}

		// scroll to footer
		var link_to_footer = $('#link-to-footer');
		link_to_footer.on('click', function(e) {
			e.preventDefault();
			var link_to_footer_target = $('a', link_to_footer).attr('href');
			$('html, body').animate({
				scrollTop: ($(link_to_footer_target).offset().top)
			},500);

			// hide menu (if in responsive mode)
			$('#main-navbar-collapse').collapse('hide');

		});

		// highlight & format carousel 
		$('#highlight-carousel-slides .highlight-item, #format-carousel-slides .format-item').each(function(el) {
			$(this).css('cursor', 'pointer');
			$(this).on('click', function(ev){
				if($(ev.target).is("a")) return;
				window.location = $(this).attr('rel');
			});
		});

		// add click action to the entire list entry in date liste (home, schedule)
		$('#events ul.schedule li, #tiles ul.tiles li').each(function(el) {
			$(this).css('cursor', 'pointer');
			$(this).on('click', function(ev){
				if($(ev.target).is("a")) return;
				window.location = $(this).attr('rel');
			});
		});

		// add click action to the entire artist list entry
		$('#datelist ul.dates li time').each(function(el) {
			if( $(this).is('[rel]') && $(this).attr('rel').length > 0 ) {
				$(this).css('cursor', 'pointer');
				$(this).on('click', function(ev){
					if($(ev.target).is("a")) return;
					window.location = $(this).attr('rel');
				});
			}
		});

		// add click action to the entire artist list entry
		$('#artists ul.artists li').each(function(el) {
			$(this).css('cursor', 'pointer');
			if( $(this).attr('rel') && $(this).attr('rel').length > 0 ) {
				$(this).on('click', function(ev){
					if($(ev.target).is("a")) return;
					window.location = $(this).attr('rel');
				});
			}
		});

		// add click action to the entire artist list entry
		$('#formats ul.formats li').each(function(el) {
			if( $(this).is('[rel]') && $(this).attr('rel').length > 0 ) {
				$(this).css('cursor', 'pointer');
				$(this).on('click', function(ev){
					if($(ev.target).is("a")) return;
					window.location = $(this).attr('rel');
				});
			}
		});

		// add click action to the entire list entry in combination list
		$('#combinations ul.combinations li').each(function(el) {
			$(this).css('cursor', 'pointer');
			$(this).on('click', function(ev){
				if($(ev.target).is("a")) return;
				window.location = $(this).attr('rel');
			});
		});

		// close cookie note
		var cookienote = $('#cookienote');
		var hidecookie = document.cookie.match('(^|;)\\s*hidecookienote\\s*=\\s*([^;]+)')?.pop() || '';
		// console.log(hidecookie);
		if (cookienote.length > 0 && hidecookie != 1) {
			cookienote.fadeIn();
			/* if (!document.cookie) {
				var expire = new Date();
				expire = new Date(expire.getTime() +1000*60*60*24*365);
				document.cookie = 'hidecookienote=1; expires=' + expire.toGMTString()+';'; 

				cookienote.fadeIn();
			} */

			$('.closenote', cookienote).click(function() {
				var expire = new Date();
				expire = new Date(expire.getTime() +1000*60*60*24*365);
				document.cookie = 'hidecookienote=1; expires=' + expire.toGMTString()+';';
				cookienote.fadeOut();
			});
			
			$('.accept', cookienote).click(function() {
				var expire = new Date();
				expire = new Date(expire.getTime() +1000*60*60*24*365);
				document.cookie = 'hidecookienote=1; expires=' + expire.toGMTString()+';';
				document.cookie = 'tracking=1; expires=' + expire.toGMTString()+';';
				cookienote.fadeOut();
			});
		}

		// load newsletter registration iframe
		var newsletter_modal = $('#newsletter_modal');
		if (newsletter_modal.length > 0) {
			$('#newsletter_notice_confirm', newsletter_modal).click(function(){
				$('#newsletter_notice', newsletter_modal).hide();
				var newsletter_iframe = $('#newsletter_iframe', newsletter_modal).attr('rel');
				$('#newsletter_iframe', newsletter_modal).attr('src', newsletter_iframe);
			});
		}

		// handle form interaction
		/* var form_registerList = $('form#registerlist');
		if (form_registerList.length > 0) {
			$('#pricecategory_reduced, #double', form_registerList).on('change, click', function(e){
				let val_reduced = $('#pricecategory_reduced', form_registerList).attr();
				let val_dpouble = $('#double', form_registerList).value();
				console.log(val_reduced, val_double);
			});
		} */



	});
})($);